import { ICardElementWithChildren } from "backend/model/model";
import getValues from "backend/values";
import * as wf from "client-api-workflow";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { useQuery } from "react-query";
import usePeriodLevels from "../model/usePeriodLevels";
import usePeriods from "../model/usePeriods";

export type TWorkflowInstance = {
  wfInstanceId: string;
  type: string;
  currentState: string;
  message: string;
  nextTransitions: string[];
  allowedActions: string[];
  meaId: string;
  period: string;
  series: string;
  latestLog?: any;
  totalWorkflowCount?: number;
  page?: number;
};

export type TWorkflowQueryParameter = {
  series: string;
  period: string;
  type: string;
};

const useMyWorkflows = <
  T extends { id: string; workflow?: TWorkflowInstance | undefined }[]
>(
  page?: number,
  rowsPerPage?: number,
  selectedWFInstanceId?: string
) => {
  const ctx = useAppContext();
  const periods = usePeriods();
  const { data: periodLevels } = usePeriodLevels();

  return useQuery(
    `data-myworkflows-${ctx.period}-${page}-${rowsPerPage}-${selectedWFInstanceId}`,
    () => {
      const params: any = {
        type: "value",
        attributes: "name",
        modelId: ctx.fullModelId,
        values: [],
      };

      if (page) params.page = page;
      if (rowsPerPage) params.rowsPerPage = rowsPerPage;
      if (selectedWFInstanceId)
        params.selectedInstanceId = selectedWFInstanceId;

      return wf.queryMyWorkflows(params).then((taskData) => {
        return Promise.all(
          taskData!.map((task) => {
            return getValues(
              task.id,
              periods!.data!.filter((n) => n.name === task.workflow?.period),
              true,
              periodLevels!
            ).then((list) => {
              return {
                ...list[0],
                workflowInstance: task.workflow,
              } as ICardElementWithChildren;
            });
          })
        );
      });
    },
    {
      keepPreviousData: false,
      enabled: !periods.isLoading && !!periodLevels,
    }
  );
};

export default useMyWorkflows;
